import React, { useEffect, useState } from 'react';
import { Button, useMediaQuery, useTheme } from '@material-ui/core';
import CopyToClipboard from 'react-copy-to-clipboard';

import { previewUrl } from 'utils/helpers';
import Toast from 'utils/toast';
import ShareIcon from 'public/icons/profile/share.svg';
import IconMainContainer from 'components/IconMainContainer';

const ShareProfile = ({ username, label }) => {
  const [url, setUrl] = useState('');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const height = {
    height: 30,
    display: 'flex',
    margin: isMobile ? '10px 15px 5px auto' : '-20px 40px 0 auto',
  };

  useEffect(() => {
    const currentUrl = previewUrl(`/u/${username}`);

    setUrl(currentUrl);
  }, [username]);

  return (
    <CopyToClipboard text={url}>
      <Button
        onClick={() => {
          Toast('success', 'Copied profile link to the clipboard!', {
            icon: <IconMainContainer src="/icons/notifications/thumb-up.svg" alt="Thumb Up" />,
          });
        }}
        color="primary"
        variant="contained"
        endIcon={<ShareIcon />}
      >
        {label}
      </Button>
    </CopyToClipboard>
  );
};

export default ShareProfile;
